import {SelectItem} from 'primeng/api';

export interface FloorMap {
  otp?: string;
  id?: number;
  name: string;
  image: string;
  mapWidth: number;
  mapHeight: number;
  details: FloorMapDetails[];
  account?: string;
  deviceStatusCode?: number;
  RegionId?: number;
}

export interface FloorMapDetails {
  id?: number;
  mapId?: number;
  name: string;
  type: string;
  ownerId: number;
  width: number;
  height: number;
  xaxes: number;
  yaxes: number;
  status?: string;
  statusCode?: number;
  isHighLightGroup: boolean;
  isGroup: boolean;
  gId?: number;
  isExpired?: boolean;
}

export interface  FloorMapFilters {
  mapOptions: number;
  statusOptions: number;
  groupOptions: number;
}

